import { Component } from '@angular/core';
import { LayoutService } from '../services/layout.service';

@Component({
  standalone: false,
  selector: 'mf-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: ['./global-spinner.component.scss'],
})
export class GlobalSpinnerComponent {
  constructor(public layoutService: LayoutService) {}
}
